import React from "react";
import BBIconTemplate from "./BBIconTemplate";

//change following import to change the image
import { ReactComponent as CustomIcon } from './raw/np_rounded-dash_331701_000000.svg';

const Icon = (props) => {
    const {style, className} = props;
    return <BBIconTemplate
        style={style}
        className={className}
        customIcon={CustomIcon}
    />
}

export default Icon;